import { render, staticRenderFns } from "./Crop.vue?vue&type=template&id=098d60aa&"
import script from "./Crop.vue?vue&type=script&lang=js&"
export * from "./Crop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiButton: require('/codebuild/output/src2284964156/src/med-el-hearpeers/components/Ui/Button/index.vue').default})
